import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEnvironmentsforUser } from '../../api/documentAPI';
import { useChatEnvironmentAtom } from '../../atoms/chat/useChatEnvironmentAtom';

import useCookie from '../../hooks/useCookie';

const EnvironmentsSelectBox = () => {
  
    const [envCookie, setCookie, ] = useCookie("ENV");
    const [loading, setLoading] = useState(true);
    const [environments, setEnvironments] = useState([]);   
    const [chatEnvironmentId, setChatEnvironmentId] = useChatEnvironmentAtom();

    const handleSelectEnvironment = (event) => {
      const selectedValue = event.target.value;
      setCookie("ENV", event.target.value);
      setChatEnvironmentId(selectedValue);
    };

    useEffect(() => {
      console.log('chat Env change: ', chatEnvironmentId);
    },[chatEnvironmentId])

    useEffect(() => {
      setLoading(true);

      getEnvironmentsforUser()
      .then((data) => {
          setEnvironments(data);
          
          if (envCookie) {
            setChatEnvironmentId(envCookie);
          }
          else if (data.length > 0 && !chatEnvironmentId) {
            setChatEnvironmentId(data[0].Id);
          }
      })
      .finally(() => setLoading(false));
    }, []);

  return (
    loading ? null :
      <div className='select-env'>
        <select value={chatEnvironmentId} onChange={handleSelectEnvironment} className='env-selectbox-tab-like '>
        {environments.map((env, index) => (
          <option key={index} value={env.Id}>
            {env.Name}
          </option>
        ))}
      </select>
      {/* <span className="material-symbols-outlined select-arrow">
            keyboard_arrow_down
      </span> */}
    </div>
  );
};

export default EnvironmentsSelectBox;
